<div bsModal #modal="bs-modal" class="modal modal-confirmation fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-create-token modal-confirmation-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row">
                    <div class="col-xs-1 offset-xs-11">
                        <i class="far fa-times-circle btn-delete" (click)="hideModal()"></i>
                    </div>
                    <div class="col-xs-10 mr-t--md text-left">
                        {{ 'You can create a new token by adding a description and a time-out to set the date until it is valid.' | translate}}
                    </div>
                    <div class="col-xs-12 mr-t--sm">
                        <ng-template [ngIf]="!formLoading">
                            <form [formGroup]="form" novalidate class="mat-form" #formDirective="ngForm">
                                <div *ngIf="errorMessage.length > 0" class="row form-group" role="alert">
                                    <div class="col-sm-10">
                                        <div class="alert alert-danger">
                                            <div *ngFor="let error of errorMessage">
                                                <i class="fas fa-exclamation-circle" aria-hidden="true"></i> {{ error | translate}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                
                                <div *ngIf="responseMessage" class="row form-group" role="alert">
                                    <div class="col-sm-10">
                                        <div class="alert-success alert">
                                            <i class="fas fa-check" aria-hidden="true"></i> {{ responseMessage | translate }}
                                        </div>
                                    </div>
                                </div>
                
                                <div class="row">
                                    <div #descriptionFG class="form-group col-xs-12">
                                        <mat-form-field class="ps-content mat-input-pill">
                                            <input type="text" matInput [placeholder]="'Description' | translate"
                                                   formControlName="description"/>
                                            <small class="form-text text-danger" [hidden]="form.controls['description'].valid
                                                                                            || (form.controls['description'].pristine
                                                                                            && !formSubmitted)">
                                                {{ 'Require at least 3 characters.' | translate }}
                                            </small>
                                        </mat-form-field>
                                    </div>
                                </div>
                                
                                <div class="row">
                                    <div class="col-xs-12 mt-2 text-xs-right">
                                        <button type="button" class="btn btn-primary btn-dark btn-create-token" (click)="submit(form.value, form.valid)">
                                            {{ 'Create token' | translate }}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>